import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RestartDeviceResult {
  success: boolean;
  error?: string | null;
  errorCode?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class DeviceControlService {
  private readonly apiUrl = `${environment.apiBaseUrl}/api/v1/DeviceManagement`;

  constructor(private http: HttpClient) {}

  /**
   * Reinicia el dispositivo Jetson.
   * @param action 'restart-engine' libera memoria GPU (~15s); 'reboot-host' no implementado aún (Fase 2).
   */
  restartDevice(action: 'restart-engine' | 'reboot-host'): Observable<RestartDeviceResult> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<RestartDeviceResult>(
      `${this.apiUrl}/restart`,
      { action },
      { headers }
    );
  }
}
